import React, { useState } from "react";
import { Alert, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

// Diálogo común para editar un traspaso o un recibo de crédito del último mes. `children` son los campos del formulario;
// `conciliado` avisa que los montos, bancos y fecha están bloqueados porque el registro ya está enlazado al extracto.
export default function EditarRegistroDialog({ titulo, id, conciliado, bloqueadosTxt, onClose, onGuardar, children }) {
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  const guardar = async (e) => {
    e.preventDefault();
    setGuardando(true);
    setError("");
    try {
      await onGuardar();
    } catch (err) {
      setError(err?.response?.data?.error || "No se pudieron guardar los cambios.");
      setGuardando(false);
    }
  };

  return (
    <Dialog open onClose={guardando ? undefined : onClose} maxWidth="md" fullWidth component="form" onSubmit={guardar}>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, py: 1.25, borderBottom: 1, borderColor: "divider" }}>
        <Typography sx={{ fontSize: 17, fontWeight: 800 }}>{titulo}</Typography>
        <Chip size="small" variant="outlined" label={`N.º ${id}`} sx={{ fontWeight: 700 }} />
        {conciliado && <Chip size="small" color="success" label="Conciliado" sx={{ fontWeight: 700 }} />}
      </DialogTitle>
      <DialogContent sx={{ p: 1.5, pt: "16px !important", display: "grid", gap: 1.25 }}>
        {error && <Alert severity="error" onClose={() => setError("")}>{error}</Alert>}
        {conciliado && (
          <Alert severity="warning" icon={<LockOutlinedIcon fontSize="small" />} sx={{ py: 0.25 }}>
            Está enlazado al extracto: {bloqueadosTxt} están <b>bloqueados</b>. Para cambiarlos, desvincúlalo primero en la conciliación.
          </Alert>
        )}
        {children}
      </DialogContent>
      <DialogActions sx={{ px: 2, py: 1, borderTop: 1, borderColor: "divider" }}>
        <Button onClick={onClose} disabled={guardando} sx={{ textTransform: "none" }}>Cancelar</Button>
        <Button type="submit" variant="contained" disabled={guardando} sx={{ textTransform: "none", fontWeight: 700, minWidth: 150 }}>
          {guardando ? <CircularProgress size={20} color="inherit" /> : "Guardar cambios"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

// Celda con el botón de editar: solo aparece en los registros del último mes.
export const columnaEditar = (onEditar, color) => ({
  h: "",
  render: (r) => (Number(r.editable) ? (
    <Button size="small" onClick={() => onEditar(r)} sx={{ minWidth: 0, p: "0 6px", fontSize: 11, fontWeight: 700, textTransform: "none", color }}>
      Editar
    </Button>
  ) : null),
});
